export const supportShadyCSS = window.ShadyCSS && !window.ShadyCSS.nativeShadow;
